import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, isStaffRole } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
    } else {
      refresh();
    }
    const onExpire = () => setUser(false);
    window.addEventListener("auth:expired", onExpire);
    return () => window.removeEventListener("auth:expired", onExpire);
  }, [refresh]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  const isStaff = !!user && isStaffRole(user.role);
  return <AuthContext.Provider value={{ user, setUser, refresh, logout, isStaff }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
